export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/DimensionsCapacity.a3e39218.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};